<template>
  <div>
    <el-row :gutter="20">
      <el-col class="integration-settings" :span="24">
        <div>
          <div v-if="integrationWizardIndex >= 0">
            <h4 class="center-text">Azure Logs Configuration</h4>
            <el-steps :active="integrationWizardIndex+1" :finish-status="apiCall.error? 'error': 'success'">
              <el-step></el-step>
              <el-step></el-step>
            </el-steps>
          </div>
          <el-carousel
            ref="wizard"
            :autoplay="false"
            :loop="false"
            indicator-position="none"
            arrow="never"
            height="400"
          >
            <el-carousel-item style="overflow: unset" :key="0">
              <div class="box flex center ">
                <el-form :v-model="integrationWizardForm" label-width="240px" label-position="left" class="full-width">
                  <el-form-item label="Integration Name">
                    <el-input
                      v-model="integrationWizardData.nickName"
                      placeholder="Enter Name for your integration"
                      @keydown.native.space.prevent
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="Event Hub Namespace">
                    <el-input 
                      v-model="integrationWizardData.eventHubNamespaceEndpoint" 
                      placeholder="Enter your Azure event hub namespace"
                      :disabled="true">
                    </el-input>
                  </el-form-item>
                  <el-form-item label="Event Hub Name">
                    <el-input
                      v-model="integrationWizardData.eventHubName"
                      placeholder="Enter your event hub name"
                      :disabled="true"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="Number of Partitions">
                    <el-input 
                      v-model="integrationWizardData.numPartitions" 
                      placeholder="Enter the number of partitions"
                      :disabled="true">
                    </el-input>
                  </el-form-item>
                  <el-form-item label="Shared Access Key Name">
                    <el-input 
                      v-model="integrationWizardData.sharedAccessKeyName" 
                      placeholder="Enter your shared access key name"
                      :disabled="true">
                    </el-input>
                  </el-form-item>
                  <el-form-item label="Shared Access Key">
                    <el-input 
                      v-model="integrationWizardData.sharedAccessKey" 
                      placeholder="Enter your shared access key"
                      :disabled="true">
                    </el-input>
                  </el-form-item>
                </el-form>
              </div>
            </el-carousel-item>            
            <el-carousel-item :key="1" class="initiated mt-20">
              <h4 class="center-text">Initiated!</h4>
              <div class="box flex" v-loading="apiCall.outbound" element-loading-spinner="el-icon-loading"></div>
              <div class="box flex mt-20 mb-20">
                <p>
                  We are connecting your Azure Monitor Logs data.
                </p>
              </div>
              <div class="box flex mt-20">
                <el-button size="medium" round @click="gotoAlertIntegrationWorkflow">View Configured Account</el-button>
              </div>
            </el-carousel-item>
            <el-carousel-item :key="2" class="initiated error mt-20">
              <h4 class="center-text">Error!</h4>
              <div class="box flex">
                <span class="center-text error-icon">
                  <i class="fas fa-exclamation-triangle"></i>
                </span>
              </div>
              <div class="box mt-20 mb-20 error-message">
                <p>
                  We could not connect to your Azure Logs account.
                </p>
                <p>
                  Troubleshoot to fix your configuration.
                </p>
                <div v-if="apiCall.error" class="box mt-20">
                  <p>
                    {{ apiCall.errorMsg.code }}:
                    {{ apiCall.errorMsg.message }}
                  </p>
                </div>
              </div>
              <div class="box flex mt-40">
                <el-button size="medium" round @click="gotoAlertIntegrationWorkflow">Troubleshoot / FAQs</el-button>
              </div>
            </el-carousel-item>
          </el-carousel>
          <div class="flex float-right">
            <span
              v-if="integrationWizardIndex >= 1"
              class="text-underline cursor-pointer back-button"
              @click="backIntegrationStep"
            >
              Go Back
            </span>
            <el-button v-if="integrationWizardIndex < 1" size="medium" round @click="updateIntegrationSettings">
              Update
            </el-button>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import integrationFormMixin from '@/components/form/integrations/integrationFormMixin'

import { AZURE_LOG_INTEGRATION_CONFIG_UPDATE_REQUEST } from '@/store/modules/integrations/azure-log-integration.type'
import { INTEGRATIONS_LIST_REQUEST } from '@/store/modules/integrations/integrations.type'
import loadDocumentationMixin from '@/mixins/loadDocumentationMixin'

export default {
  name: 'EditAzureLogIntegrationWorkflow',
  mixins: [integrationFormMixin, loadDocumentationMixin],
  data () {
    return {
      integrationWizardIndex: 0,
      integrationLastStep: 2,
      integrationWizardSteps: new Array(2).fill(''),
      apiDispatchState: AZURE_LOG_INTEGRATION_CONFIG_UPDATE_REQUEST
    }
  },
  methods: {
    removeSpaces () {
      this.integrationWizardData.nickName = this.integrationWizardData.nickName.split(' ').join('')
    },
    gotoIntegrationWorkflow () {
      this.$router.push({
        name: 'discoveryintegration-accounts'
      })
    },   
    callApi () {
      this.$store.dispatch(INTEGRATIONS_LIST_REQUEST).then(integrations => {        
        this.apiCalled = true
        for (let accountKey of Object.keys(integrations)) {
          if (this.$route.params.accountKey === accountKey) {
            this.integrationWizardData = integrations[accountKey].config
            this.integrationWizardData.accountKey = accountKey
            this.integrationWizardData.active = true
            this.integrationWizardData.key = accountKey
          }
        }
      })
    }
  },
  created () {
    if (!_.isEmpty(this.azureLogIntegrationConfig.nickName)) {
      this.integrationWizardData = this.azureLogIntegrationConfig
    }
    if (!this.$_.isEmpty(this.$route.params) && _.isNil(this.integrationWizardData.active)) {
      this.callApi()
    }
  },
  computed: {
    ...mapGetters(['azureLogIntegrationConfig'])
  },
  watch: {},
  components: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/integration_workflow.css';

</style>



// WEBPACK FOOTER //
// src/components/form/integrations/edit/EditAzureLogIntegrationWorkflow.vue